import config from "../../config"
import RequestService from "../RequestService"

const createWaiver = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrlV2}/waivers`, { waiver: params }, successCallback, failureCallback)
}

export default createWaiver;